import 'jquery';
// import 'what-input';

import { Foundation } from 'foundation-sites/js/foundation.core';
// import 'foundation-sites/js/foundation.util.box';
import { Keyboard } from 'foundation-sites/js/foundation.util.keyboard';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
import { Motion } from 'foundation-sites/js/foundation.util.motion';
// import 'foundation-sites/js/foundation.util.nest';
// import 'foundation-sites/js/foundation.util.timerAndImageLoader';
// import 'foundation-sites/js/foundation.util.touch';
import { Triggers } from 'foundation-sites/js/foundation.util.triggers';

// import 'foundation-sites/js/foundation.abide';
// import { Accordion } from 'foundation-sites/js/foundation.accordion';
// import 'foundation-sites/js/foundation.accordionMenu';
// import 'foundation-sites/js/foundation.drilldown';
// import 'foundation-sites/js/foundation.dropdown';
// import 'foundation-sites/js/foundation.dropdownMenu';
// import 'foundation-sites/js/foundation.equalizer';
// import 'foundation-sites/js/foundation.interchange';
// import 'foundation-sites/js/foundation.magellan';
// import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas';
// import 'foundation-sites/js/foundation.orbit';
// import 'foundation-sites/js/foundation.responsiveMenu';
// import 'foundation-sites/js/foundation.responsiveToggle';
import { Reveal } from 'foundation-sites/js/foundation.reveal';
// import 'foundation-sites/js/foundation.slider';
// import { SmoothScroll } from 'foundation-sites/js/foundation.smoothScroll';
// import { Sticky } from 'foundation-sites/js/foundation.sticky';
// import 'foundation-sites/js/foundation.tabs';
// import 'foundation-sites/js/foundation.toggler';
// import 'foundation-sites/js/foundation.tooltip';

import './components/assignments';
import './components/directors';
import './components/slider';
import './components/sticky-header';

Foundation.addToJquery(jQuery);
Foundation.Keyboard = Keyboard;
Foundation.MediaQuery = MediaQuery;
Foundation.Reveal = Reveal;
Foundation.Triggers = Triggers;

Foundation.plugin(Reveal, 'Reveal');

jQuery(document).foundation();
